import React, { useState, useEffect, useCallback, useContext } from "react";
import { OrganicationNavbar } from "./reusedcomponent/navbar";
import CreateassetCategoriesModal from "./modal/create_asset_categories";
import CreateAssert from "./modal/create_assert";
import { ApiService } from "../../../services/ApiService";
import { useAlert } from "react-alert";
import EditassetModal from "./modal/edit_asset";
import { ConfirmTemplate } from "../../../components/confirm";
import Modal from "react-modal";
import useModal from "../../../utils/useModal";
import moment from "moment";
import { AuthContext } from "../../../Context/AuthContext";
import { PageBody } from "../../../components/loader";
import { useLoadingMessage } from "../../../components/useLoadingMessage";
import { capitalize } from "../../../utils/capitalize";
import { formattCurrency } from "../../../utils/formatCurrency";

import { orgarnizationMngtThunk } from "../../../store/actions/organizationmanagement/orgarnization.thunk";
import { systemConfigThunk } from "../../../store/actions/systemconfiguration/systemconfig.thunk";
import { employeeMngtThunk } from "../../../store/actions/employeemanagement/employee.thunk";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    background: "white",
    transform: "translate(-50%, -50%)",
    // border: "2px solid green",
  },
};

Modal.setAppElement("#root");

export const OrganizationIndex = () => {
  const { user } = useContext(AuthContext);
  const alert = useAlert();
  const { isLoading, message, updateLoader } = useLoadingMessage();
  const [editValue, setEditValue] = useState([]);
  const [searchAssets, setSearchAssets] = useState("");
  const [allCat, setAllCat] = useState("");
  const { modalIsOpen, openModal, closeModal } = useModal();

  const { assetsCat, allAssets } = useSelector(
    (state) => state.orgarnizationMngt
  );
  const { employees } = useSelector((state) => state.employeeMngt);
  const { offices } = useSelector((state) => state.systemConfig);

  const dispatch = useDispatch();

  const [assertModalOpen, setAssertModalOpen] = useState(false);
  const [assertCategoriesModalOpen, setAssertCategoriesModalOpen] =
    useState(false);

  const openAssertModal = () => {
    setAssertModalOpen(true);
  };

  const openAssertCategoriesModal = () => {
    setAssertCategoriesModalOpen(true);
  };

  const closeAssetsModal = () => {
    setAssertModalOpen(false);
    setAssertCategoriesModalOpen(false);
  };

  const deleteAsset = (asset_id) => {
    const request = async () => {
      const res = await ApiService.delete(`assets/delete-asset/${asset_id}`);
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        orgarnizationMngmnt();
      }
    };
    ConfirmTemplate(
      {
        title: "Delete Asset",
        message: "Are You Sure You Want To Delete This Asset",
      },
      request
    );
  };

  const orgarnizationMngmnt = useCallback(async () => {
    updateLoader(true, "Getting all assets");
    await dispatch(orgarnizationMngtThunk.getAssetsCart());
    await dispatch(orgarnizationMngtThunk.getAllAssets());
    await dispatch(employeeMngtThunk.getEmployeesDetails());
    await dispatch(systemConfigThunk.getOffices());
    updateLoader(false);
  }, [dispatch]);

  useEffect(() => {
    orgarnizationMngmnt();
  }, []);

  const AllAssets = allAssets.filter((asset) => {
    return (
      (asset &&
        asset.name.toLowerCase().indexOf(searchAssets.toLowerCase()) !== -1) ||
      asset.description.toLowerCase().indexOf(searchAssets.toLowerCase()) !== -1
    );
  });

  return (
    <React.Fragment>
      <PageBody isLoading={isLoading} message={message}>
        <Modal
          isOpen={assertModalOpen}
          onRequestClose={closeAssetsModal}
          style={customStyles}
          contentLabel="view user datails modal"
        >
          <CreateAssert
            closeModal={closeAssetsModal}
            users={employees}
            offices={offices}
            assetscategories={assetsCat}
            alert={alert}
            getAllAssets={orgarnizationMngmnt}
          />
        </Modal>
        <OrganicationNavbar />
        <Modal
          isOpen={assertCategoriesModalOpen}
          onRequestClose={closeAssetsModal}
          style={customStyles}
          contentLabel="view user datails modal"
        >
          <CreateassetCategoriesModal
            users={employees}
            offices={offices}
            assetscategories={assetsCat}
            alert={alert}
            closeModal={closeAssetsModal}
            getAllAssets={orgarnizationMngmnt}
          />
        </Modal>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="view user datails modal"
        >
          <EditassetModal
            users={employees}
            offices={offices}
            assetscategories={assetsCat}
            alert={alert}
            getAllAssets={orgarnizationMngmnt}
            value={editValue}
            closeModal={closeModal}
          />
        </Modal>

        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <div className="card-title">
                      <div className="table-title">
                        <div className="row container-fluid">
                          <div className="col-sm-6">
                            <h2>
                              <b>OFFICE </b>ASSET
                            </h2>
                          </div>

                          {(user.data.user.roles &&
                            user.data.user.roles.name === "admin") ||
                          user.data.user.roles.name === "human resource" ? (
                            <div className="col-sm-6">
                              <button
                                onClick={openAssertModal}
                                id="add_asset_btn"
                                className="btn nt-button-color-action trigger-btn"
                              >
                                <i className="material-icons">&#xE147;</i>{" "}
                                <span> ADD ASSET</span>
                              </button>
                              <button
                                className="btn nt-button-color-action"
                                data-toggle="modal"
                                onClick={openAssertCategoriesModal}
                              >
                                <i className="material-icons">&#xE147; </i>{" "}
                                <span>ADD ASSET CATEGORY</span>
                              </button>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="mb-3 clearfix">
                      <div
                        class="btn-group float-left"
                        role="group"
                        aria-label="Basic example"
                      >
                        <button
                          type="button"
                          class="btn btn-secondary btn-group-sm"
                          onClick={() => window.print()}
                        >
                          Print
                        </button>
                        <ReactHTMLTableToExcel
                          id="test-table-xls-button"
                          className="btn btn-secondary btn-group-sm"
                          table="office-asset"
                          filename="OFFICE ASSETS"
                          sheet="tablexls"
                          buttonText="Export to excel"
                        />
                      </div>

                      <form class="form-inline my-2 my-lg-0 float-right">
                        <input
                          class="form-control mr-sm-2"
                          type="search"
                          placeholder="Search"
                          aria-label="Search"
                          name="search"
                          value={searchAssets}
                          onChange={(e) => setSearchAssets(e.target.value)}
                        />
                      </form>
                    </div>

                    <div className="table-responsive" id="printTable">
                      <table
                        // id="office_assets_view"
                        id="office-asset"
                        className="table table-bordered asset-table"
                      >
                        {AllAssets < 1 ? (
                          <div className="text-center m-auto">
                            <h1 className="text-dark">No record found</h1>
                          </div>
                        ) : (
                          <thead>
                            <tr>
                              <th>SN</th>
                              <th>Asset Name</th>
                              <th>Description</th>
                              <th>Category</th>
                              <th>Date Acquired</th>
                              <th>Beneficiary</th>
                              <th>Price</th>
                              <th>Office</th>

                              <th className="notexport">Action</th>
                            </tr>
                          </thead>
                        )}
                        <tbody>
                          {AllAssets.map((asset, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{capitalize(asset.name)}</td>
                              <td>{capitalize(asset.description)}</td>
                              <td>{capitalize(asset.category.name)}</td>
                              <td>{moment(asset.date_added).format("ll")}</td>
                              <td>
                                {asset.user !== null &&
                                  capitalize(asset.user.first_name) +
                                    " " +
                                    capitalize(asset.user.last_name)}
                              </td>
                              <td>₦ {formattCurrency(asset.price)}</td>
                              <td>
                                {asset.office !== null &&
                                  capitalize(asset.office.name)}
                              </td>
                              <td>
                                <a
                                  className="edit_asset"
                                  id="edit_asset"
                                  onClick={() => {
                                    const value = {
                                      id: asset.id,
                                      name: asset.name,
                                      description: asset.description,
                                      asset_category: asset.category.id,
                                      date_acquired: asset.date_added,
                                      beneficiary: asset.user.id,
                                      price: asset.price,
                                      office: asset.office.id,
                                    };
                                    setEditValue(value);
                                    openModal();
                                  }}
                                >
                                  <i
                                    className="material-icons"
                                    data-toggle="tooltip"
                                    title="Edit"
                                  >
                                    &#xE254;
                                  </i>
                                </a>
                                <a
                                  id="delete_asset"
                                  className="delete"
                                  onClick={() => {
                                    deleteAsset(asset.id);
                                  }}
                                >
                                  <i
                                    className="material-icons"
                                    data-toggle="tooltip"
                                    title="Delete"
                                  >
                                    &#xE872;
                                  </i>
                                </a>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageBody>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/organizationmanagement/index.js